var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({class:['xmas-decoration-lights', 'pointer-events-none', _vm.className],style:(_vm.style)},'div',_vm.remainingProps,false),_vm._l((_vm.backgroundClasses),function(bgClass,index){return _c('div',{key:index,class:[bgClass, { visible: index === _vm.currentImageIdx, hidden: index !== _vm.currentImageIdx }],style:({
      opacity: index === _vm.currentImageIdx ? 1 : 0,
      position: 'absolute',
      height: '100%',
      width: '100%',
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }